import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmt } from "@/lib/format";
import { KLayout, KDemo } from "@/pages/kreonis/KLayout";
import { Seo } from "@/components/Seo";
import { PriceChart } from "@/components/PriceChart";

export default function KAnalyst() {
  const [regime, setRegime] = useState(null);
  const [assets, setAssets] = useState([]);
  const [sel, setSel] = useState("BTC/USD");
  const [snap, setSnap] = useState(null);
  const [candles, setCandles] = useState([]);
  useEffect(() => { api.get("/markets/regime").then((r) => setRegime(r.data)).catch(() => {}); api.get("/markets").then((r) => setAssets(r.data.assets)).catch(() => {}); }, []);
  useEffect(() => {
    const e = encodeURIComponent(sel);
    api.get(`/markets/${e}/snapshot?timeframe=4h`).then((r) => setSnap(r.data)).catch(() => {});
    api.get(`/markets/${e}/candles?timeframe=4h&bars=120`).then((r) => setCandles(r.data.candles)).catch(() => {});
  }, [sel]);
  return (
    <KLayout>
      <Seo title="KREONIS — AI Macro Regime & Asset Breakdown" />
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <div className="flex items-center justify-between"><h1 className="font-display text-3xl font-bold text-slate-50">AI Macro Regime & Asset Breakdown</h1><KDemo /></div>
        {regime && (
          <div className="mt-6 rounded-2xl border border-slate-800 bg-slate-900/50 p-6" data-testid="kanalyst-regime">
            <div className="text-xs uppercase tracking-wider text-slate-500">Current Macro Regime</div>
            <div className="mt-1 font-display text-3xl font-bold text-emerald-400">{regime.regime}</div>
            <p className="mt-2 text-slate-400">{regime.reason}</p>
            <div className="mt-3 flex gap-6 text-sm text-slate-300"><span>Bullish breadth: <b>{regime.bullish}</b></span><span>Bearish: <b>{regime.bearish}</b></span><span>Avg volatility: <b>{regime.avg_volatility}%</b></span></div>
          </div>
        )}
        <div className="mt-6 grid gap-6 lg:grid-cols-3">
          <div className="rounded-2xl border border-slate-800 bg-slate-900/50 p-4">
            <select value={sel} onChange={(e) => setSel(e.target.value)} data-testid="kanalyst-asset" className="w-full rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-sm text-slate-200">
              {assets.map((a) => <option key={a.symbol} value={a.symbol}>{a.symbol}</option>)}
            </select>
            <div className="mt-4"><PriceChart candles={candles} height={180} color="#10b981" /></div>
          </div>
          {snap && (
            <div className="lg:col-span-2 grid grid-cols-2 gap-3 sm:grid-cols-3">
              {[["Structure", snap.trend], ["Trend Strength", `${snap.trend_strength}/100`], ["RSI", fmt(snap.rsi, 1)], ["MACD hist", fmt(snap.macd.hist, 3)], ["Volatility", `${snap.volatility} (${snap.volatility_pct}%)`], ["Support", fmt(snap.support)], ["Resistance", fmt(snap.resistance)], ["EMA20", fmt(snap.ema20)], ["AI Bias", snap.ai_bias]].map(([l, v]) => (
                <div key={l} className="rounded-xl border border-slate-800 p-3"><div className="text-[10px] uppercase tracking-wider text-slate-500">{l}</div><div className="mt-1 font-mono text-sm font-semibold capitalize text-slate-100">{v}</div></div>
              ))}
            </div>
          )}
        </div>
      </div>
    </KLayout>
  );
}
